module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('messages.404')))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.home')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-585cb7ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 67
// module chunks = 1